import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight, Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { siteInfo, images } from '@/data/mock';

export const LocationSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="inline-block text-sm uppercase tracking-wider text-[var(--color-gold)] font-medium mb-4">
              Notre Localisation
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl text-[var(--text-primary)] mb-6">
              Au cœur des Monts d'Arrée
            </h2>
            <div className="w-24 h-px bg-[var(--color-gold)] mb-8"></div>
            
            <p className="text-lg text-[var(--text-secondary)] leading-relaxed mb-6">
              Situé à Plounéour-Ménez, au cœur du Finistère en Bretagne, 
              notre élevage bénéficie d'un cadre naturel préservé, 
              idéal pour l'épanouissement de nos Bengals et Maine Coons.
            </p>

            <div className="flex items-start gap-3 mb-8">
              <MapPin className="w-5 h-5 text-[var(--color-gold)] mt-1 flex-shrink-0" />
              <div>
                <p className="font-medium text-[var(--text-primary)]">
                  Plounéour-Ménez
                </p>
                <p className="text-[var(--text-subtle)]">
                  Finistère (29), Bretagne, France
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact">
                <Button className="btn-primary group">
                  Nous contacter
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <a href={`tel:${siteInfo.phone.replace(/\s/g, '')}`}>
                <Button variant="outline" className="btn-outline">
                  <Phone className="w-4 h-4 mr-2" />
                  {siteInfo.phone}
                </Button>
              </a>
            </div>
          </div>

          {/* Map & Image */}
          <div className="space-y-6">
            {/* Brittany landscape image */}
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src={images.brittany1}
                alt="Paysage de Bretagne - Monts d'Arrée"
                className="w-full h-64 object-cover"
              />
            </div>
            
            {/* Map */}
            <div className="map-container h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d21095.36881252088!2d-3.8674799!3d48.4534799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4816d4b4c5a5d0c7%3A0x40ca5cd36e4ab30!2s29410%20Ploun%C3%A9our-M%C3%A9nez!5e0!3m2!1sfr!2sfr!4v1699999999999!5m2!1sfr!2sfr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localisation Maison Bengal & Coon - Plounéour-Ménez"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
